export const isNumberKey = key => /^[0-9]$/.test(key);
export const isLetter = key => /^[a-zA-Z\s]$/.test(key);
export const isAlphabetKey = key => /^[0-9a-zA-Z]$/.test(key);
export const validateName = input => /^[a-zA-Z\s]{0,35}$/.test(input);
export const validatePassport = (val) => /^[0-9a-zA-Z]{0,35}$/.test(val);